import React from 'react'
import MessageUtils from '../../util/MessageUtils'
import './ButtonTiny.css'

const ButtonTinyUI = function(props) {
  const buttonProps = {};
  Object.keys(props).forEach(key => {
    if (['label', 'messageList', 'className', 'labelKey', 'onClick', 'rowId', 'disabled'].indexOf(key) === -1) {
      buttonProps[key] = props[key];
    }
  });
  
  return (
    <button
      className={`w_btn_tiny ${props.className ? props.className : ''} ${props.disabled ? 'disabled' : ''}`}
      type='button'
      onClick={props.onClick}
      data-row-id={props.rowId}
      disabled={props.disabled}
      {...buttonProps}
    >
      {
        props.label &&
        <React.Fragment>{props.label}</React.Fragment>
      }
      {
        props.labelKey &&
        <React.Fragment>
          {MessageUtils.getMessageValue(props.messageList, props.labelKey)}
        </React.Fragment>
      }
    </button>
  );
}

export default ButtonTinyUI
